<template>
  <div class="header-top">
    <h1><img src="/resource/img/goldwind-white.png" alt=""></h1>
    <h1 class="first-title"><span class="title">{{ title }}</span></h1>
    <div class="current-date"><span class="line-level blue"></span>{{ currentTime }}<span class="line blue"></span>{{ currentDate }}<span class="line blue"></span>{{ currentDay }}</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'HeaderTop',
  data () {
    return {
      currentTime: '',
      currentDate: '',
      currentDay: '',
      timer: null
    }
  },
  props: {
    title: String
  },
  mounted () {
    this.updateDate()
    this.timer = setInterval(this.updateDate, 1000);
  },
  methods: {
    updateDate() {
      const now = new Date()
      this.currentTime = dayjs(now).format('HH:mm:ss')
      this.currentDate = dayjs(now).format('YYYY.MM.DD')
      const datas = dayjs(now).day()
      var week = ['日', '一', '二', '三', '四', '五', '六']
      this.currentDay = '星期' + week[datas]
    }
  },
  beforeUnmount () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang="scss" scoped>
.header-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  box-sizing: border-box;
  padding: 15px 50px;
  z-index: 1;
  h1 {
    font-size: 32px;
    font-weight: 800;
    color: #FFFFFF;
    letter-spacing: 2px;
    img {
      height: 36px;
      vertical-align: middle;
    }
    .title{
      display: inline-block;
      //padding-left: 30px;
      line-height: 40px;
      vertical-align: middle;
      //&::before{
      //  content: "";
      //  display: inline-block;
      //  width: 2px;
      //  height: 24px;
      //  opacity: 0.6;
      //  background: #fff;
      //  margin-right: 30px;
      //  vertical-align: middle;
      //}
    }
  }
  .first-title{
    flex: 1;
    padding-left: 30px;
    //margin-left: 30px;
  }
  .current-date{
    //padding-top: 4px;
    font-size: 20px;
    font-weight: 800;
    color: #D9E7FF;
    line-height: 40px;
    transform: scale(0.8);
    transform-origin: right;
    margin-top: 10px;
    *{
      vertical-align: middle;
    }
  }
  .blue{
    margin: 0 14px;
  }
  .line-level{
    display: inline-block;
    width: 12px;
    height: 2px;
    background: #01B1FD;
    box-shadow: 0px 0px 4px 1px #00B7F4;
  }
  .line{
    display: inline-block;
    width: 3px;
    height: 18px;
    line-height: 1;
    margin-top: -9px;
    &:before,
    &:after{
      content: "";
      display: block;
      width: 3px;
      height: 10px;
      background: #01B1FD;
      box-shadow: 0px 0px 8px 0 #00B7F4;
    }
    &:after{
      margin-top: 4px;
    }
  }
}
</style>
